<script lang="ts">
  import { stateToParamsMapping } from "@retailer/services/filter_params_from_state_params";
  import ProductLinesContainer from "@retailer/svelte/ProductLines/ProductLineContainer/ProductLinesContainer.svelte";
  import { params } from "@roxi/routify";
  import TrackingContext from "@shared/svelte/Components/Tracking/TrackingContext.svelte";
  import { CustomContentProductCatalogEntity } from "@shared/services/event_tracking/entities";

  export let Cart = null;
  export let title: string;
  export let mobileMode: boolean;
  export let overridePath: string = "/sc/:slug";
  export let baseStateParamType: string;
  export let baseStateParamId: number;
  export let position: number;
  export let id: number;

  // Unused props passed from discovery panel
  export let type: string | null = null;
  type;

  const stateParamTypeMapping = {
    WineCountry: stateToParamsMapping.country_id.menu_param,
    Manufacturer: stateToParamsMapping.manufacturer_id.menu_param,
    WineRegion: stateToParamsMapping.region_id.menu_param,
    Distributor: stateToParamsMapping.distributor_ids.menu_param,
    WineAppellation: stateToParamsMapping.appellation_id.menu_param,
    Tag: stateToParamsMapping.tag_id.menu_param,
    BrandFamily: stateToParamsMapping.brand_family_id.menu_param,
  };

  let customContentStateParams = {};
  const buildBaseStateParams = () => {
    const resultParams = {};
    if (baseStateParamType && baseStateParamId && stateParamTypeMapping[baseStateParamType]) {
      resultParams[stateParamTypeMapping[baseStateParamType]] = baseStateParamId;
    }
    return resultParams;
  };
  const baseStateParams = buildBaseStateParams();
  $: {
    customContentStateParams = { slug: $params.slug, ...$params, ...baseStateParams };
  }

  const trackingEntity = new CustomContentProductCatalogEntity({
    id: id,
    position: position,
    base_state_param_type: baseStateParamType,
    base_state_params: baseStateParams,
  });
</script>

<TrackingContext entities={trackingEntity}>
  <div class="fizz-styles" data-testid="product-catalog-component">
    <div class="fizz-container fizz-inset-square-16 fizz-flex-column-responsive">
      <h2 class="fizz-heading-2 fizz-stack-16">
        {title}
      </h2>

      <ProductLinesContainer
        {Cart}
        {mobileMode}
        {overridePath}
        stateParams={{}}
        overrideStateParams={customContentStateParams}
      />
    </div>
  </div>
</TrackingContext>
